var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lv_flexalign_center act_layout"},[_c('div',{staticClass:"act_button",on:{"click":_vm.remove}},[_vm._v("删除选中")]),_c('div',{staticClass:"act_button",on:{"click":_vm.clear}},[_vm._v("全部删除")])])
}
var staticRenderFns = []

export { render, staticRenderFns }